/**
 * Custom hook to get environment variables
 * @returns {{
 *   getEnv: (function(string): (string|undefined)),
 *   isEnvTruthy: (function(string): boolean)
 * }}
 */
const useEnv = () => {
    const isProduction = process.env.NODE_ENV === 'production';
    const isDev = process.env.NODE_ENV === 'development';

    /**
     * Get env variable from process.env or window object (in dev)
     * @param {string} key
     * @returns {string|undefined}
     */
    const getEnv = (key) => {
        const wholeKey = `REACT_APP_${key}`;
        // In development mode, we can get the env variable from the URL (for testing purposes)
        if (isDev) {
            const params = new URLSearchParams(document.location.search);
            if (params.has(wholeKey)) {
                return params.get(wholeKey);
            }
        }
        return process.env[wholeKey];
    }

    /**
     * Return true if env variable is set to 1
     * @param {string} key
     * @returns {boolean}
     */
    const isEnvTruthy = (key) => {
        return getEnv(key)?.toString() === '1' || getEnv(key)?.toString() === 'true';
    }

    return {
        isProduction,
        isDev,
        getEnv,
        isEnvTruthy
    }
}

export default useEnv;
